import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'c-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss']
})
export class LoadingComponent implements OnInit {

  @Input() loading: string;

  constructor() { }

  ngOnInit() {
  }

}
